import type {
  ReplayChunkData,
  ReplayData,
  ReplayManifest,
} from "@/lib/demo-parser";

export function assembleReplayData(
  manifest: ReplayManifest,
  chunks: ReplayChunkData[]
): ReplayData | null {
  if (!manifest.replay) {
    return null;
  }

  const orderedChunks = [...chunks].sort(
    (left, right) => left.roundNumber - right.roundNumber
  );
  const frames = orderedChunks.flatMap((chunk) => chunk.frames ?? []);
  if (frames.length === 0) {
    return null;
  }

  return {
    ...manifest.replay,
    frames,
    weaponFires: orderedChunks.flatMap((chunk) => chunk.weaponFires ?? []),
    grenades: orderedChunks.flatMap((chunk) => chunk.grenades ?? []),
    deaths: orderedChunks.flatMap((chunk) => chunk.deaths ?? []),
    playerBlinds: orderedChunks.flatMap((chunk) => chunk.playerBlinds ?? []),
    hurtEvents: orderedChunks.flatMap((chunk) => chunk.hurtEvents ?? []),
    bulletDamages: orderedChunks.flatMap((chunk) => chunk.bulletDamages ?? []),
    bombsPlanted: orderedChunks.flatMap((chunk) => chunk.bombsPlanted ?? []),
    bombDrops: orderedChunks.flatMap((chunk) => chunk.bombDrops ?? []),
    bombPickupTicks: orderedChunks.flatMap((chunk) => chunk.bombPickupTicks ?? []),
    bombDefuseStarts: orderedChunks.flatMap((chunk) => chunk.bombDefuseStarts ?? []),
    bombDefuses: orderedChunks.flatMap((chunk) => chunk.bombDefuses ?? []),
    grenadeTrajectories: orderedChunks.flatMap(
      (chunk) => chunk.grenadeTrajectories ?? []
    ),
    sprayEpisodes: orderedChunks.flatMap((chunk) => chunk.sprayEpisodes ?? []),
  };
}
